import React from 'react'

import KinerjaKSPerencanaanApp from 'app/KinerjaKSPage/pages/Perencanaan'
import KinerjaLayout from 'app/KinerjaShared/components/KinerjaLayout'
import { useAPIKinerja } from 'api/kinerja/useAPIKinerjaKS'
import ContentProvider from 'app/KinerjaKSPage/components/ContentProvider'
import { SchoolProvider } from 'app/KinerjaKSPage/components/SchoolContentProvider'
import { parseQuery } from 'utils/router'
import { getServerSidePropsWithToggle } from 'utils/toggle.server'
import { TOGGLE_KEYS } from 'configs/toggle-feature'
import { PENGELOLAAN_KINERJA_NOT_FOUND_PATH } from 'app/KinerjaShared/constants/path'
import { PageGuardKSPNF } from 'app/KinerjaKepalaSKBPage/components/PageGuardKSPNF'
import useSchoolContext from 'app/KinerjaKSPage/hooks/useSchoolContext'
import { KinerjaTipeProvider } from 'app/KinerjaShared/components/KinerjaTipeProvider'

import type { KinerjaKs } from 'types/kinerja-ks'
import type { Jenjang } from 'types/kinerja'
import type { TToggleKeyValuePair } from 'configs/toggle-feature'
import type { NextPageContext } from 'next'

export const getServerSideProps = getServerSidePropsWithToggle({
  toggleKeys: TOGGLE_KEYS.filter((key) => key.includes('kinerja')),
  serverProps: async (
    context: NextPageContext,
    toggle: TToggleKeyValuePair
  ) => {
    const enabled = toggle?.['kinerja-spnf-enabled'] || false
    const npsn = parseQuery<string>(context.query.id) as string

    if (!enabled) {
      return {
        redirect: {
          destination: PENGELOLAAN_KINERJA_NOT_FOUND_PATH,
          permanent: false,
        },
      }
    }

    return { props: { npsn } }
  },
})

const KinerjaKSPNFPerencanaan = ({
  skp,
  isSkpFetched,
}: {
  skp: KinerjaKs
  isSkpFetched: boolean
}) => {
  const { isLoadingSchools, selectedSchool } = useSchoolContext()

  if (isLoadingSchools) {
    return null
  }

  return (
    <KinerjaTipeProvider tipe="SPNF">
      <ContentProvider
        jenjang={skp?.jenjang as Jenjang}
        isSkpFetched={isSkpFetched}
        role={selectedSchool?.role}
      >
        <KinerjaKSPerencanaanApp skp={skp} isSKPFetched={isSkpFetched} />
      </ContentProvider>
    </KinerjaTipeProvider>
  )
}

const WrappedKinerjaKSPNFPerencanaan = ({ npsn }: { npsn: string }) => {
  const { data: { data: skp } = {}, isFetched: isSkpFetched } = useAPIKinerja(
    npsn,
    { enabled: !!npsn }
  )

  return (
    <PageGuardKSPNF>
      <SchoolProvider>
        <KinerjaKSPNFPerencanaan skp={skp} isSkpFetched={isSkpFetched} />
      </SchoolProvider>
    </PageGuardKSPNF>
  )
}

WrappedKinerjaKSPNFPerencanaan.Layout = KinerjaLayout

WrappedKinerjaKSPNFPerencanaan.layoutOpts = {
  hasHeader: true,
}

export default WrappedKinerjaKSPNFPerencanaan
